import React from 'react';
import { Icon, Text, theme } from 'components';
import styled from 'styled-components';
import {
  ILoadingAttachments,
  ISharedAttachment,
} from 'hooks/contextualChat/useMediaAttachments';
import { Loading } from '@app/react-common';

interface ILinksTab {
  linksDict?: Record<string, Array<ISharedAttachment>>;
  loading?: ILoadingAttachments;
}

const LinksTab = ({ linksDict, loading }: ILinksTab) => (
  <>
    {!Object.keys(linksDict).length ? (
      <Text style={{ textAlign: 'center', marginTop: 12 }}>
        No links shared yet
      </Text>
    ) : (
      <>
        {Object.entries(linksDict).map(([month, links]) => (
          <div key={`month-${month}`} style={{ paddingTop: 24 }}>
            <Text color={theme.textColorSecondary}>{month}</Text>
            <StyledLinksContainer>
              {links.map((link, idx) => (
                <a
                  key={`document-${link.title}-idx`}
                  href={link?.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <StyledLink>
                    <StyledImageContainer>
                      {link?.image ? (
                        <StyledImg
                          src={link.image}
                          alt={`preview-${link.image}-${idx}`}
                        />
                      ) : (
                        <Icon
                          type="pictureOutlined"
                          width="100%"
                          height="100%"
                        />
                      )}
                    </StyledImageContainer>
                    <StyledTextContainer>
                      <Text ellipsis>{link.title}</Text>
                      <Text ellipsis>{link.description}</Text>
                      <Text ellipsis style={{ fontWeight: 600 }}>
                        {link?.link}
                      </Text>
                    </StyledTextContainer>
                  </StyledLink>
                </a>
              ))}
            </StyledLinksContainer>
          </div>
        ))}
        {loading.query && <Loading />}
      </>
    )}
  </>
);

const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  justify-content: center;
  max-width: 178px;
`;

const StyledImageContainer = styled.div`
  min-width: 75px;
  max-width: 75px;
  display: flex;
`;

const StyledLinksContainer = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const StyledLink = styled.div`
  display: flex;
  min-height: 85px;
  flex: 1;
  gap: 12px;
  background-color: #fff;
  border: 0.5px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    border: 0.5px solid ${theme.getColor('primary')};
  }
`;

const StyledImg = styled.img`
  display: block;
  object-fit: cover;
  max-width: 100%;
  min-height: 100%;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export default LinksTab;
